import Pikaday from 'pikaday/pikaday';

function getNumberOfDays(date1: Date, date2: Date) {
  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;

  // Calculating the time difference between two dates
  const diffInTime = date2.getTime() - date1.getTime();

  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
}

const enableStep51 = () => {
  document.querySelector('[data-step-51]').classList.remove('hide');
  document.querySelector('[data-step-6]').innerHTML = '7';
}

const disableStep51 = () => {
  document.querySelector('[data-step-51]').classList.add('hide');
  document.querySelector('[data-step-6]').innerHTML = '6';
}

/*
* This function builds the subscription quiz
*/
export const initSubscriptionQuiz = (): void => {
  const triggerBtn = document.querySelectorAll('[data-subscription-quiz-trigger]');
  const subscriptionFor = document.querySelectorAll('[data-sub-for]');
  const subscriptionOwner = document.querySelectorAll('[data-sub-owner]');
  const contentSection = document.querySelector('[data-subscription-content]');
  const quizSection = document.querySelector('[data-subscription-quiz]') as HTMLDivElement;
  const quizBackSection = document.querySelector('[data-quiz-back]') as HTMLDivElement;
  const landingPage = quizBackSection ? quizBackSection.dataset.quizBack : '';
  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search))

  // steps
  const quizSteps = document.querySelector('[data-quiz-steps]') as HTMLDivElement;
  if (!quizSteps) { return }
  const stepOne = quizSteps.querySelector('[data-step-1]') as HTMLDivElement;
  const stepTwo = quizSteps.querySelector('[data-step-2]') as HTMLDivElement;
  const stepThree = quizSteps.querySelector('[data-step-3]') as HTMLDivElement;
  const stepFour = quizSteps.querySelector('[data-step-4]') as HTMLDivElement;
  const stepFive = quizSteps.querySelector('[data-step-5]') as HTMLDivElement;
  const stepFiveOne = quizSteps.querySelector('[data-step-51]') as HTMLDivElement;
  const stepSix = quizSteps.querySelector('[data-step-6]') as HTMLDivElement;

  let userAnswers = {
    q1: { text: '', option: '' },
    q2: { text: '', option: '' },
    q3: { text: '', option: '' },
    q4: { text: '', option: '' },
    q5: { text: '', option: '' },
    q51: { text: '', option: '' },
    product: {}
  }

  const localStorageVar = localStorage.getItem('subscripionQuizAnswers')

  if (localStorageVar !== null) {
    userAnswers = JSON.parse(localStorageVar)
    if (userAnswers.q1.option === '2') {
      enableStep51()
    }
  }

  // Initiate pikaday calendar
  const calendarInput: HTMLInputElement = document.querySelector('[data-calendar-value]');
  if (calendarInput) {
    const picker = new Pikaday({
      onSelect: function () {
        // calendarInput.value = picker.toString();
        calendarInput.setAttribute('data-answer-option', picker.toString());
        if (calendarInput.classList.contains('hide')) {
          calendarInput.classList.remove('hide');
        }
      },
      toString(date) {
        const today = new Date();
        today.setHours(1);
        return getNumberOfDays(today, date);
      },
      disableWeekends: true,
      minDate: new Date(),
    });
    calendarInput.parentNode.insertBefore(picker.el, calendarInput);
  }

  // common actions
  const goToSpecificStep = (step) => {
    // if we're not already on the landing page(i.e. we're on the results page)
    // we'll need to redirect back to it so we can open the quiz to the selected step
    if (!window.location.href.includes(landingPage)) {
      window.location.href = landingPage + '?step=' + step + '&open-quiz=true'
      return
    }

    step = step.toString()
    quizSection.dataset.currentStep = step
    quizSteps.dataset.currentStep = step
    window.scrollTo(0, 0)

  }

  const goToNextStep = () => {
    const nextStep = parseInt(quizSection.dataset.currentStep) + 1
    goToSpecificStep(nextStep)
  }

  const hideQuiz = () => {
    quizSection.classList.remove('show')
    contentSection.classList.remove('hide')
    quizBackSection.classList.add('hide')
    window.scrollTo(0, 0)
  }

  const goToPreviousStep = () => {
    let previousStep = 0
    if (quizSection) {
      const currentStep = parseInt(quizSection.dataset.currentStep);
      // Handle going back from step 51
      previousStep = currentStep - (currentStep === 51 ? 46 : 1)
    } else {
      // going back from pdp
      const quizAnswers = JSON.parse(localStorage.getItem('subscripionQuizAnswers'))
      if (quizAnswers) {
        previousStep = quizAnswers.q51.option ? 51 : 5
      }
    }

    // If we are going "back"
    if (previousStep <= 0) {
      hideQuiz()
      return
    }
    goToSpecificStep(previousStep)
  }

  const displayQuiz = () => {
    quizSection.classList.add('show')
    contentSection.classList.add('hide')
    quizBackSection.classList.remove('hide')
    window.scrollTo(0, 0)
  }

  const setNaming = () => {
    subscriptionOwner.forEach(el => {
      el.innerHTML = userAnswers.q1.option === '1' ? 'your' : 'their'
    })

    subscriptionFor.forEach(el => {
      el.innerHTML = userAnswers.q1.text
    })
  }

  const openQuizToStep = (step) => {
    userAnswers = JSON.parse(localStorage.getItem('subscripionQuizAnswers'))
    stepOne.classList.add('completed')
    stepTwo.classList.add('completed')
    stepThree.classList.add('completed')
    stepFour.classList.add('completed')
    stepFive.classList.add('completed')
    stepFiveOne.classList.add('completed')
    stepSix.classList.add('completed')
    displayQuiz()
    goToSpecificStep(step)
    setNaming()
  }

  // if local storage = gift then remove class of hide

  if (urlParams.get('open-quiz') && urlParams.get('step')) {
    openQuizToStep(urlParams.get('step'))
  }

  stepOne.addEventListener('click', () => {
    if (stepOne.classList.contains('completed')) {
      goToSpecificStep(1)
    }
  })

  stepTwo.addEventListener('click', () => {
    if (stepTwo.classList.contains('completed')) {
      goToSpecificStep(2)
    }
  })

  stepThree.addEventListener('click', () => {
    if (stepThree.classList.contains('completed')) {
      goToSpecificStep(3)
    }
  })

  stepFour.addEventListener('click', () => {
    if (stepFour.classList.contains('completed')) {
      goToSpecificStep(4)
    }
  })

  stepFive.addEventListener('click', () => {
    if (stepFive.classList.contains('completed')) {
      goToSpecificStep(5)
    }
  })

  stepFiveOne.addEventListener('click', () => {
    if (stepFiveOne.classList.contains('completed')) {
      goToSpecificStep(51)
    }
  })

  quizBackSection.addEventListener('click', () => {
    goToPreviousStep()
  })


  if (triggerBtn.length <= 0) return;

  if (!quizSection) { return }

  // questions
  const questionOne = document.querySelectorAll('[data-question-1] button');
  const questionTwo = document.querySelectorAll('[data-question-2] button');
  const questionThree = document.querySelectorAll('[data-question-3] button');
  const questionFour = document.querySelectorAll('[data-question-4] button');
  const questionFive = document.querySelectorAll('[data-question-5] button');
  const questionFiveOne = document.querySelectorAll('[data-question-51] button');

  //product URLS
  const essentialsSmallBike = JSON.parse(quizSection.dataset.essentialsSmallBike)
  const essentialsSmallEBike = JSON.parse(quizSection.dataset.essentialsSmallEbike)
  const essentialsLargeBike = JSON.parse(quizSection.dataset.essentialsLargeBike)
  const essentialsLargeEBike = JSON.parse(quizSection.dataset.essentialsLargeEbike)
  const enthusiastSmallBike = JSON.parse(quizSection.dataset.enthusiastSmallBike)
  const enthusiastSmallEBike = JSON.parse(quizSection.dataset.enthusiastSmallEbike)
  const enthusiastLargeBike = JSON.parse(quizSection.dataset.enthusiastLargeBike)
  const enthusiastLargeEBike = JSON.parse(quizSection.dataset.enthusiastLargeEbike)


  const essentialsSmallBikeGift = JSON.parse(quizSection.dataset.essentialsSmallBikeGift)
  const essentialsSmallEBikeGift = JSON.parse(quizSection.dataset.essentialsSmallEbikeGift)
  const essentialsLargeBikeGift = JSON.parse(quizSection.dataset.essentialsLargeBikeGift)
  const essentialsLargeEBikeGift = JSON.parse(quizSection.dataset.essentialsLargeEbikeGift)
  const enthusiastSmallBikeGift = JSON.parse(quizSection.dataset.enthusiastSmallBikeGift)
  const enthusiastSmallEBikeGift = JSON.parse(quizSection.dataset.enthusiastSmallEbikeGift)
  const enthusiastLargeBikeGift = JSON.parse(quizSection.dataset.enthusiastLargeBikeGift)
  const enthusiastLargeEBikeGift = JSON.parse(quizSection.dataset.enthusiastLargeEbikeGift)

  const redirectUserToChosesnProduct = () => {
    let packageType = ''
    let product = { url: '', name: '' }
    const isEbike = userAnswers.q5.option === '2'
    const isGift = userAnswers.q1.option === '2'

    // work out what type of package the user needs
    switch (userAnswers.q2.option) {
      case '1':
        if (userAnswers.q3.option === '3') {
          packageType = 'ess-l'
        } else {
          packageType = 'ess-s'
        }
        break;

      case '2':
        if (userAnswers.q3.option === '1') {
          packageType = 'ess-l'
        } else if (userAnswers.q3.option === '2') {
          packageType = 'enth-s'
        } else {
          packageType = 'enth-l'
        }
        break;

      case '3':
        if (userAnswers.q3.option === '1') {
          packageType = 'enth-s'
        } else {
          packageType = 'enth-l'
        }
        break;
    }

    // switch between the bike and e-bike versions
    switch (packageType) {
      //essentials small
      case 'ess-s':
        if (isEbike) {
          product = isGift ? essentialsSmallEBikeGift : essentialsSmallEBike
        } else {
          product = isGift ? essentialsSmallBikeGift : essentialsSmallBike
        }
        break;

      //essentials large
      case 'ess-l':
        if (isEbike) {
          product = isGift ? essentialsLargeEBikeGift : essentialsLargeEBike
        } else {
          product = isGift ? essentialsLargeBikeGift : essentialsLargeBike
        }
        break;

      //enthusiasts small
      case 'enth-s':
        if (isEbike) {
          product = isGift ? enthusiastSmallEBikeGift : enthusiastSmallEBike
        } else {
          product = isGift ? enthusiastSmallBikeGift : enthusiastSmallBike
        }
        break;

      //enthusiasts large
      case 'enth-l':
        if (isEbike) {
          product = isGift ? enthusiastLargeEBikeGift : enthusiastLargeEBike
        } else {
          product = isGift ? enthusiastLargeBikeGift : enthusiastLargeBike
        }
        break;
    }
    userAnswers.product = product

    localStorage.setItem('subscripionQuizAnswers', JSON.stringify(userAnswers))

    window.location.href = product.url
  }

  // Toggle buttons
  triggerBtn.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      displayQuiz()
    });
  });

  questionOne.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      goToNextStep()
      stepOne.classList.add('completed')
      userAnswers.q1 = { text: btn.dataset.answerValue, option: btn.dataset.answerOption }

      if (btn.dataset.answerOption === '2') {
        enableStep51();
      } else {
        disableStep51();
      }
      setNaming()
    });
  });

  questionTwo.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      goToNextStep()
      stepTwo.classList.add('completed')
      userAnswers.q2 = { text: btn.dataset.answerValue, option: btn.dataset.answerOption }
    });
  });

  questionThree.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      goToNextStep()
      stepThree.classList.add('completed')
      userAnswers.q3 = { text: btn.dataset.answerValue, option: btn.dataset.answerOption }
    });
  });

  questionFour.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      goToNextStep()
      stepFour.classList.add('completed')
      userAnswers.q4 = { text: btn.dataset.answerValue, option: btn.dataset.answerOption }
    });
  });

  questionFiveOne.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {
      quizSection.classList.add('loading')
      btn.disabled = true
      stepFiveOne.classList.add('completed');
      userAnswers.q51 = { text: btn.dataset.answerOption, option: btn.dataset.answerOption };

      redirectUserToChosesnProduct()
    });
  });

  questionFive.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', () => {

      stepFive.classList.add('completed')
      userAnswers.q5 = { text: btn.dataset.answerValue, option: btn.dataset.answerOption }

      // If it's a gift, take the user to the date picker step.
      if (userAnswers.q1.option === '2') {
        goToSpecificStep('51');
        
      } else {
        quizSection.classList.add('loading')
        btn.disabled = true
        userAnswers.q51 = { text: '', option: '' };

        redirectUserToChosesnProduct()
      }
    });
  });
}
